import { BaseSmartDBFrontEndTxApiCalls } from 'smart-db';
import { OTCEntity } from '../Entities/OTC.Entity';

export class OTCApi extends BaseSmartDBFrontEndTxApiCalls {
    protected static _Entity = OTCEntity;

    // #region api

    // #endregion api
}
